// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile_1sAmC","mobile":"Tile_mobile_3p27A","tileText":"Tile_tileText_228QG"};